class PriceSnippet extends HTMLElement {
  static observedAttributes = [
    "dynamic",
    "price",
    "compare-at-price",
    "currency",
    "trailing-zeros",
  ];

  constructor() {
    super();
  }

  connectedCallback() {
    this._init();
  }

  attributeChangedCallback() {
    this._init();
  }

  get price() {
    return parseFloat(this.getAttribute("price"));
  }

  get compareAtPrice() {
    return parseFloat(this.getAttribute("compare-at-price"));
  }

  get currency() {
    return this.getAttribute("currency") || "USD";
  }

  get trailingZeros() {
    return this.hasAttribute("trailing-zeros") ? 2 : 0;
  }

  get dynamic() {
    return this.hasAttribute("dynamic");
  }

  _init() {
    if (!this.dynamic) return;

    const onSale = this.compareAtPrice > 0 && this.compareAtPrice > this.price;

    if (onSale) {
      this.innerHTML = `
      <span>
        <span class="visually-hidden">${window.priceStrings.regularPrice}</span>
        <span>
          <s class="price__item price__item--regular">
            ${window.formatMoney(
              this.compareAtPrice,
              this.trailingZeros,
              this.currency,
            )}
          </s>
        </span>
      </span>
      <span>
        <span class="visually-hidden">${window.priceStrings.salePrice}</span>
        <span class="price__item price__item--sale">
          ${window.formatMoney(this.price, this.trailingZeros, this.currency)}
        </span>
      </span>
      `;
    } else {
      this.innerHTML = `
        <span>
          <span class="visually-hidden">${
            window.priceStrings.regularPrice
          }</span>
          <span class="price__item price__item--regular">
            ${window.formatMoney(this.price, this.trailingZeros, this.currency)}
          </span>
        </span>
      `;
    }
  }
}

if (!customElements.get("price-snippet")) {
  customElements.define("price-snippet", PriceSnippet);
}
